import template from './template.html';

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '='
    },
    template,
    controller: [
      '$rootScope',
      '$scope',
      ($rootScope, $scope) => {
        $scope.currentUser = $rootScope.currentUser;
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/bookingGuests/index.js